export const esUA = {
    estudiar: {
        plan_estudios: {
            recomendados: {
                titulo: "Planes de Clases Recomendados"
            }
        }
    }
}
